/** @jsx jsx */
import { forwardRef, type ForwardedRef } from 'react';
import { css, jsx } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { Link, type LinkProps } from '@atlassian/react-resource-router';

/**
 * This aims to address the a11y issues reported in [ENGHEALTH-10934](https://hello.jira.atlassian.cloud/browse/ENGHEALTH-10934).
 *
 * Also worth pointing out that the a11y issues reported is only an issue in the context of cypress and how it
 * runs Storybook examples. Due to some [historical technical reasons](https://atlassian.slack.com/archives/C02785CLSTW/p1734910857523639),
 * we can't load design system tokens in Storybook when cypress runs its tests. This causes the fallback
 * color value to be used which fails the test(s). The newer version of `token()` doesn't require a fallback to be
 * passed and will provide a more appropriate and up to date value for the fallback.
 */
function IssueKeyLink(props: LinkProps, ref: ForwardedRef<HTMLButtonElement | HTMLAnchorElement>) {
	return <Link ref={ref} {...props} css={issueKeyLinkStyles} />;
}

const issueKeyLinkStyles = css({
	color: token('color.text.subtle'),
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	':hover': {
		color: token('color.text.subtle'),
	},
	fontWeight: token('font.weight.regular'),
	paddingRight: token('space.150', '12px'),
});

export const IssueKey = forwardRef(IssueKeyLink);
